export default __webpack_public_path__ + "static/media/aj4.613a56d4.png";